/**
 * Flashpoint-related types for FP Race game mode: difficulties, factions, the
 * race definition the server builds from platform data, and round selections.
 */
/**
 * Display labels for flashpoint difficulties
 */
export const FLASHPOINT_DIFFICULTY_LABELS = {
    SM: 'Story Mode',
    VM: 'Veteran Mode',
    MM: 'Master Mode',
};
